export class IUserInfo {   
    userId: string;
    userName: string;
    name: string;
    organizationId: string;
    organizationName: string;
    role: string[];
    photoUrl: string;
    accessToken: string;
    phone: string;
    email: string;
    lastLoginDate: string;
    status: string;
    constructor(){}
}

export class IUserInProject extends IUserInfo {
    id: string;
    constructor(){
        super();
    }
}